"use client";

import { useEffect, useState } from "react";

type AppSettings = {
  announcementEnabled?: boolean;
  announcementHtml?: string;
};

export function GuideAnnouncement() {
  const [announcementHtml, setAnnouncementHtml] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetch("/api/app-settings")
      .then((res) => res.ok ? res.json() as Promise<AppSettings> : null)
      .then((data) => {
        if (data?.announcementEnabled && data.announcementHtml) {
          setAnnouncementHtml(data.announcementHtml);
        }
      })
      .catch(() => {});
  }, []);

  if (!announcementHtml) return null;

  return (
    <>
      <button
        type="button"
        className="guide-announcement-bar"
        onClick={() => setOpen(true)}
      >
        <span>公告</span>
        <span
          className="announcement-rich-content love-announcement-preview"
          dangerouslySetInnerHTML={{ __html: announcementHtml }}
        />
        <strong>查看详情</strong>
      </button>
      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="guide-announcement-title"
          className="guide-announcement-modal"
          onClick={() => setOpen(false)}
        >
          <section onClick={(event) => event.stopPropagation()}>
            <header>
              <h2 id="guide-announcement-title">公告</h2>
              <button type="button" onClick={() => setOpen(false)} aria-label="关闭公告">
                ×
              </button>
            </header>
            <div className="announcement-rich-content" dangerouslySetInnerHTML={{ __html: announcementHtml }} />
          </section>
        </div>
      )}
    </>
  );
}
